export default {
      id: "boss_y-usage",
      viewBox: "-21 -117 682.66672 682",
      url: "/public/build/images/" + "../../../../images/sprite.svg#boss_y",
      toString: function () {
        return this.url;
      }
    }